module.exports = "<p>\r\n  genericmodal works!\r\n</p>\r\n"